import { render, staticRenderFns } from "./RestaurantReservationRow.vue?vue&type=template&id=0caff036&scoped=true&"
import script from "./RestaurantReservationRow.vue?vue&type=script&lang=js&"
export * from "./RestaurantReservationRow.vue?vue&type=script&lang=js&"
import style0 from "./RestaurantReservationRow.vue?vue&type=style&index=0&id=0caff036&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0caff036",
  null
  
)

export default component.exports